// App.js
import React, { useState, Suspense, lazy } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";

// ✅ Lazy-load the widget page so it doesn't execute on initial load
const TestWidget = lazy(() => import("./test_widget"));

function HomePage() {
  // ---- your original code (unchanged) ----
  const [code, setCode] = useState("");
  const [isCodeCorrect, setIsCodeCorrect] = useState(false);
  const [downloadMessage, setDownloadMessage] = useState("");
  const [showVideo, setShowVideo] = useState(false);

  const verifyCode = () => {
    const currentDate = new Date();
    const mmdd = `${currentDate.getMonth() + 1}${currentDate.getDate()}`;
    if (code === mmdd) setIsCodeCorrect(true);
    else {
      alert("Incorrect code. Please try again.");
      setIsCodeCorrect(false);
    }
  };

  const handleDownload = (fileName, fileUrl) => {
    setDownloadMessage("Please wait... downloading");
    const anchor = document.createElement("a");
    anchor.href = fileUrl;
    anchor.download = fileName;
    anchor.click();
    setTimeout(() => {
      setDownloadMessage(
        "Downloading will be finishing soon, please go to files and then downloads and once fully downloaded click on it to install it."
      );
    }, 10000);
  };

  const toggleVideo = () => setShowVideo(!showVideo);

  return (
    <div className="app-container">
      <h1>Welcome to Pharmace Digital download portal</h1>

      <div className="download-buttons">
        <button className="button-download-1" onClick={() => handleDownload("getscreen.apk", "https://pharmaceinstall.co.uk/getscreen.apk")}>
          Download getscreen.me
        </button>

        <div className="download-item">
          <button className="button-download-2" onClick={() => handleDownload("m1.apk", "https://pharmaceinstall.co.uk/m1.apk")}>
            Download scan to shelf to scanner PDA - uninstall first please
          </button>
          <img src="/m1.gif" alt="QR Code for Scan to Shelf" className="qr-code" />
        </div>

        <div className="download-item">
          <img src="/m3.gif" alt="QR Code for Delivery App" className="qr-code" />
          <button className="button-download-3" onClick={() => handleDownload("delscan.apk", "https://pharmaceinstall.co.uk/delscan.apk")}>
            Download 2D barcode delivery to scanner PDA - uninstall first please
          </button>
        </div>
      </div>

      <div className="tutorial-buttons">
        <button className="button-play-store" onClick={() => window.open("https://play.google.com/store/apps/details?id=com.pharmace.driverdeliveryapp", "_blank")}>
          Download delivery app for Android from Play Store
        </button>
        <button className="button-app-store" onClick={() => window.open("https://apps.apple.com/app/driverdeliveryapp0-1/id6714477839", "_blank")}>
          Download delivery app for iOS from App Store
        </button>
        <button className="button-camera-delivery" onClick={() => handleDownload("delcam.apk", "https://pharmaceinstall.co.uk/delcam.apk")}>
          Download Camera delivery app for Android directly from Pharmace - uninstall first please
        </button>
        <button className="button-epos_android" onClick={() => handleDownload("epos.apk", "https://pharmaceinstall.co.uk/epos.apk")}>
          Download EPOS android apk from Pharmace - update or install
        </button>
        <button onClick={() => window.open("https://pharmaceinstall.co.uk/patientapp.apk", "_blank")}>
          Download Pharmace messaging
        </button>
        <button onClick={() => window.open("https://pharmaceinstall.co.uk/m1titan.apk", "_blank")}>
          Download Scan to shelf for Titan
        </button>
        <button onClick={() => window.open("https://pharmaceinstall.co.uk/m1staging.apk", "_blank")}>
          Download Scan to shelf for staging
        </button>

        <a
          href="https://pharmaceinstall.co.uk/netmon.html"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "inline-block",
            padding: "10px",
            marginBottom: "10px",
            cursor: "pointer",
            textDecoration: "none",
          }}
        >
          <button type="button" style={{ cursor: "pointer" }}>
            Open Wifi monitoring tool
          </button>
        </a>

                <button onClick={() => window.open("https://pharmaceinstall.co.uk/PharmaceEpos/PharmaceEposSetup.exe", "_blank")}>
          Download Epos installation
        </button>

      </div>

      <button
        style={{ backgroundColor: "yellow", padding: "10px", marginBottom: "10px", border: "none", cursor: "pointer" }}
        onClick={() => handleDownload("inventory.apk", "https://pharmaceinstall.co.uk/inventory.apk")}
      >
        Download inventory app for scanner
      </button>

      {/* Link to the widget test page */}
      <Link to="/test-widget">
        <button style={{ padding: "10px", marginBottom: "10px", cursor: "pointer" }}>
          Test widget
        </button>
      </Link>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      {/* Suspense shows a small fallback while the widget chunk loads */}
      <Suspense fallback={<div style={{ padding: 16 }}>Loading…</div>}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/test-widget" element={<TestWidget />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}